<template>
  <div>
    <v-overlay
        :opacity="1"
        :value="showredirectLoading"
    >
      <v-progress-circular indeterminate size="64">
        Загрузка цен...
      </v-progress-circular>
    </v-overlay>
    <v-navigation-drawer
        v-if="!result"
        v-model="drawer"
        :permanent="permanentDrawer"
        app
        :style="navStyle"
        mobile-breakpoint="1000"
        v-bind:width="drawersWidth"
    >
      <v-toolbar v-if="!isMobile">

        <v-toolbar-title >
          Тарифный калькулятор
        </v-toolbar-title>

        <v-spacer></v-spacer>

      </v-toolbar>
      <v-list v-if="isMobile" style="padding: 0px 0px !important;">
        <v-list-item style="">
          <template>
            <v-row
            >
              <v-dialog
                  v-model="dialog"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      block
                      color="primary"
                      dark
                      small
                      style="margin-left: auto !important; margin-right: 12px;"
                  >
                    Объем
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar>
                    <v-toolbar-title v-if="!result">Данные о потреблении, кВтч</v-toolbar-title>
                    <v-toolbar-title v-if="result">Расчет стоимости э/э для потребителя {{ zone_name }} за {{
                        monthName
                      }}
                      {{ year }} года {{ category_name }} ; {{ voltage_name }}
                    </v-toolbar-title>
                    <v-spacer>
                    </v-spacer>
                    <strong v-if="!result" style="margin-left: 32px;">Объем э/э: {{ toRound(sum) }} кВтч</strong>
                    <strong
                        v-if="power && !result" style="margin-left: 32px;">Объем мощности: {{ toRoundPower(power) }}
                      МВт</strong>
                    <v-btn
                        icon

                        @click="dialog = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <ColorVolume :arr="vol.arr"></ColorVolume>
                  <v-footer >
      <span v-if="!result">
        <v-chip
            class="ma-2"
            style="width: 30px; height: 20px; background-color: #FFFFA1FF; border: #333333 1px solid">
        </v-chip>&nbsp; - выходные дни &nbsp;&nbsp;&nbsp;
          <v-chip style="width: 30px; height: 20px; background-color: #ffcccc; border: #333333 1px solid"> </v-chip> &nbsp; - часы максимума нагрузки энергосистемы


      </span>
                    <v-spacer></v-spacer>
                  </v-footer>

                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-date-picker
          v-model="picker"
          :max="getEndDate"

          :month-format="getCustomMonth"
          color="primary"
          dense
          full-width
          locale="ru"
          min="2021-01-01"
          next-icon="mdi-skip-next"

          prev-icon="mdi-skip-previous"
          type="month"
          width=""
          year-icon="mdi-calendar-blank"
          @change="updateChecking"
      ></v-date-picker>
      <v-list style="padding: 0px 0px !important;">
        <v-list-item>
          <v-autocomplete v-model="region_id" :items="regions" dense density="comfortable" item-text="label"
                          item-value="value" label="Субъект РФ" variant="outlined"
          >
            <template v-slot:prepend-inner>
              <Help v-if="help"  text="Выбор субъекта Российской Федерации в котором производится потребление электрической энергии"></Help>
            </template>
          </v-autocomplete>
        </v-list-item>
        <v-list-item v-if="region_id && zones[1]">
          <v-select v-model="zone_id" :items="zones" dense density="comfortable" item-text="label"
                    item-value="value" label="Зона деятельности " variant="outlined"
          >
          </v-select>
        </v-list-item>

        <v-list-item>
          <v-row>
            <v-col>
              <v-select  v-model="category" :items="categories" dense density="comfortable" item-text="label"
                        item-value="value" label="Максимальная мощность" variant="outlined"
              >

                <template v-slot:prepend-inner>
                  <Help v-if="help"  text="Максимальная мощность энергопринимающешго устройства, подтверждённая актом разграничения балансовой принадлежности, либо актом о техническом присоединении"></Help>

                </template>

              </v-select>
            </v-col>
            <v-col v-if="tr=='mrsk'">
              <v-select v-model="voltage_level" :items="voltage_levels" dense density="comfortable" item-text="label"
                        item-value="level" label="Уровень напряжения " variant="outlined"
              >
                <template v-slot:prepend-inner>
                  <Help v-if="help"  text=" Уровень напряжения энергопринимающего устройства в соответствии с договором энергоснабжения с гарантирующим поставщиком либо договором купли-продажи с сетевой организацией."></Help>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-list-item>
        <v-list-item>
          <v-select v-model="tr" :items="trs" dense density="comfortable" item-text="label"
                    item-value="value" label="Услуга по передаче " variant="outlined"
          >
          </v-select>
        </v-list-item>
      </v-list>

      <v-card flat>
        <v-list>
          <div style="padding: 6px;">
            <template>
              <div style="display: flex; align-items: center; width: 100%;">
                <v-btn v-if="!help" small color="primary" @click="getFromBuffer" style="flex: 1; max-width: calc(100% - 40px);">
                  ВСТАВИТЬ ИЗ БУФЕРА
                </v-btn>

                <v-menu :close-on-content-click="false" v-model="menu123" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small  color="primary" @click="menu123 = true" style="margin-left: 8px;">
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-textarea style="width: 220px;" rows="3" v-model="manualInput" label="Введите данные из буфера" @input="processManualInput"></v-textarea>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <v-tooltip v-if="help" bottom style="width: 32px;">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="help"  v-bind="attrs"
                       v-on="on"  small block color="primary" @click="getFromBuffer()">ВСТАВИТЬ ИЗ
                  БУФЕРА <v-btn style="margin-left: 4px;" x-small >?</v-btn>
                </v-btn>
              </template>
              <span>Вставка ранее скопированного объема (Excel , HTML и др. ) почасового потребленият в формате матрицы 31 на 24 либо столбца из 720 или 744 значений в зависимости от выбранного периода. </span>
            </v-tooltip>
          </div>
          <div>
            <v-row style="padding: 6px;">
              <v-col>
                <v-btn v-if="!help"  small block color="primary" @click="getTemplate()">Скачать шаблон</v-btn>
                <v-tooltip v-if="help" bottom style="width: 32px;">
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs"
                             v-on="on" small block color="primary" @click="getTemplate()">Скачать шаблон <v-btn style="margin-left: 4px;" x-small >?</v-btn></v-btn>
                  </template>
                  <span>Скачать шаблон для заполнения данных о почасовом потребления. </span>
                </v-tooltip>
              </v-col>
              <v-col>
                <input id="ifile" ref="file" placeholder="123" style="display: none" type="file"
                       @change="onFileChange"/>
                <v-btn v-if="!help" small block color="primary" @click="selectFile()">Загрузить
                  файл
                </v-btn>
                <v-tooltip v-if="help" bottom style="width: 32px;">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs"
                           v-on="on" small block color="primary" @click="selectFile()">Загрузить
                      файл <v-btn style="margin-left: 4px;" x-small >?</v-btn>
                    </v-btn>
                  </template>
                  <span> Загрузить заполненный шаблон </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </div>
          <div style="padding: 6px;">
            <v-row>
              <v-col>
                <PricesTarifs :help="help" :sum="sum" :category_name="category_name" :voltage_name="voltage_name"
                              :btn_ability="btnAbility"
                              :arr="vol.arr" :title="pricecesTarifsTitle" :month="month" :host="host" :year="year"
                              :zone_id="zone_id"
                              :region_id="region_id" :voltage_level="voltage_level" :category="category"></PricesTarifs>
              </v-col>
              <v-col>
                <v-btn
                    v-if="!result"
                    block
                    small
                    color="primary"
                    style="margin-top: auto; margin-right: 24px;"
                    @click="calculate()"
                >
                  Рассчитать
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-list>

      </v-card>
      <!--    <v-list-item>
            <v-list-item-title>
              <small>Единицы измерения</small>
            </v-list-item-title>
            <v-radio-group
                v-if="!result"
                style="margin-top: 12px;"
                dense
                v-model="mv"
                row>

              <v-radio
                  label="кВт"
                  value="kvt"
              ></v-radio>
              <v-radio
                  label="МВт"
                  value="mvt"
              ></v-radio>
            </v-radio-group>
          </v-list-item>-->
      <v-footer app :style="footerStyle">
        <v-btn icon fab small @click="toVk">
          <img style="width:20px; height: 20px; cursor: pointer;" src="../assets/vk.png">
        </v-btn>
        <v-btn icon fab small @click="toTg">
          <img style="width:20px; height: 20px; cursor: pointer;" src="../assets/tg.png">
        </v-btn>
        <ModalInfo style="margin-left: 2px;"></ModalInfo>
        <template>
          <v-switch
              dense
              @change="helpChange"
              v-model="help"
              label="Помощь"
          ></v-switch>
        </template>
      </v-footer>
    </v-navigation-drawer>
    <div v-if="isMobile && result">
      <v-app-bar app flat>
        <v-toolbar-title v-if="result">Расчет стоимости э/э для потребителя {{ zone_name }} за {{ monthName }} {{
            year
          }} года {{ category_name }} ; {{ voltage_name }}
        </v-toolbar-title>
      </v-app-bar>
      <ResultTable :isMobile="isMobile" v-if="vol.sum" :dkp="dkp" :result="results" :sum="vol.sum" :type="mv" :link="'https://etarif.ru/cached-result?calculation='+ calculation_id" :description="'Расчет стоимости э/э для потребителя ' + zone_name + ' за '+  monthName +' '+ year + ' года ' +  category_name + ';' + voltage_name"></ResultTable>
    </div>
    <div v-if="!isMobile">
      <v-app-bar app flat>
        <v-toolbar-title v-if="!result">Данные о потреблении, кВтч</v-toolbar-title>
        <v-toolbar-title v-if="result">Расчет стоимости э/э для потребителя {{ zone_name }} за {{ monthName }} {{
            year
          }} года {{ category_name }} <span v-if="tr=='mrsk'">; {{ voltage_name }}</span>
        </v-toolbar-title>
        <v-spacer>
        </v-spacer>
        <strong v-if="!result" style="margin-left: 32px;">Объем э/э: {{ toRound(sum) }} кВтч</strong> <strong
          v-if="power && !result" style="margin-left: 32px;">Объем мощности: {{ toRoundPower(power) }} МВт</strong>
      </v-app-bar>
      <v-main  :class="mainStyle" style="overflow:scroll; ">
        <div id="calc">
          <div v-if="!result">
            <template>
              <v-card>
                <v-row v-if="vol.arr[0]">
                  <v-progress-linear v-if="checking"></v-progress-linear>
                  <ColorVolume :arr="vol.arr"></ColorVolume>
                </v-row>
              </v-card>
            </template>
            <v-card
                v-if="!haveVolume"
                class="mb-12">

              <v-row>
                <v-col>
                  <v-text-field
                      v-model="consuption"
                      label="Потребление "
                  ></v-text-field>
                  <v-select v-model="client_type" :items="client_types" item-text="name"
                            item-value="type"
                            label="Действующая ценовая категория"
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-checkbox v-model="hasEP" label="Наличие ПУ">
                  </v-checkbox>
                </v-col>
              </v-row>


            </v-card>
            <!-- <v-btn v-if="haveVolume" text @click="haveVolume=false">
               у меня нет объема потрбления
             </v-btn>-->
            <v-btn v-if="!haveVolume" text @click="haveVolume=true">
              у меня есть почасовой объем потрбления
            </v-btn>

          </div>
          <div v-if="result">
            <v-btn
                v-if="!result"
                color="primary"
                style="margin-top: auto;"
                @click="calculate()"
            >
              Рассчитать

            </v-btn>
            <!--<h3 style="text-align: center;">Расчет стоимости э/э по потребителю {{category_name}} ; {{voltage_name}}  {{ zone_name }} за {{ monthName }} {{ year }} года</h3>
             <h4 style="text-align: center;">в зоне деятельности {{ zone_id.label }}</h4>-->
              <ResultTable :isMobile="isMobile" v-if="vol.sum" :dkp="dkp" :result="results" :sum="vol.sum" :type="mv" :link="'https://etarif.ru/cached-result?calculation='+ calculation_id" :description="'Расчет стоимости э/э для потребителя ' + zone_name + ' за '+  monthName +' '+ year + ' года ' +  category_name + ';' + voltage_name"></ResultTable>
          </div>
        </div>
      </v-main>
      <v-footer app inset style="margin-bottom: 64px;" v-if="!result">
      <span v-if="!result">
        <v-chip
            class="ma-2"
            style="width: 30px; height: 20px; background-color: #FFFFA1FF; border: #333333 1px solid">
        </v-chip>&nbsp; - выходные дни &nbsp;&nbsp;&nbsp;
          <v-chip style="width: 30px; height: 20px; background-color: #ffcccc; border: #333333 1px solid"> </v-chip> &nbsp; - часы максимума нагрузки энергосистемы


      </span>
        <v-spacer></v-spacer>
      </v-footer>
    </div>
  </div>

</template>

<script>
import router from './../router/index.js'
import ModalInfo from ".//ModalInfo";
import PricesTarifs from "./PricesTarifs";

//import Handsontable from "handsontable";
//import "handsontable/dist/handsontable.full.css";
import axios from 'axios';
//import Bars from 'vuebars'
import * as XLSX from 'xlsx'
//import VolumeModal from './Volume.vue'
import ColorVolume from './ColorVolume'
import ResultTable from "@/components/ResultTable";
import Help from "@/components/Help";


export default {
  name: 'TarifCalc',
  props: ['isMobile'],
  components: {
    Help,
    //  VolumeModal,
    ResultTable,
    ColorVolume,
    ModalInfo,
    PricesTarifs
  },

  data: () => ({
    manualInput: "",
    menu123: false,
    help:false,
    showredirectLoading:false,
    calculation_id:'',
    know: true,
    sh: true,
    file: null,
    results: {
      total_value: {
        ck1: 1,
        ck3: 2,
        ck4: 3,
      },
      electric: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      power: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      transfer_service1: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      transfer_service2: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      sn_gp: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      org_cost: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      price: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
    },
    power: '',
    showVolume: true,
    nowDate: new Date().toISOString().slice(0, 10),
    date: new Date(),
    countries: ['RU'],
    contactForm: {
      type: 'Потребитель',
      fio: '',
      region: 'Москва',
      phone: '',
    },
    roles: ['Генератор', 'Потребитель'],
    regionsC: [
      'Адыгея',
      'Алтай',
      'Алтайский край',
      'Амурская область',
      'Архангельская область',
      'Астраханская область',
      'Башкортостан',
      'Белгородская область',
      'Брянская область',
      'Бурятия',
      'Владимирская область',
      'Волгоградская область',
      'Вологодская область',
      'Воронежская область',
      'Дагестан',
      'Еврейская АО',
      'Забайкальский край',
      'Ивановская область',
      'Ингушетия',
      'Иркутская область',
      'Кабардино-Балкария',
      'Калининградская область',
      'Калмыкия',
      'Калужская область',
      'Камчатский край',
      'Карачаево-Черкесия',
      'Карелия',
      'Кемеровская область',
      'Кировская область',
      'Коми',
      'Костромская область',
      'Краснодарский край',
      'Красноярский край',
      'Крым',
      'Курганская область',
      'Курская область',
      'Ленинградская область',
      'Липецкая область',
      'Магаданская область',
      'Марий Эл',
      'Мордовия',
      'Москва',
      'Московская область',
      'Мурманская область',
      'Ненецкий АО',
      'Нижегородская область',
      'Новгородская область',
      'Новосибирская область',
      'Омская область',
      'Оренбургская область',
      'Орловская область',
      'Пензенская область',
      'Пермский край',
      'Приморский край',
      'Псковская область',
      'Ростовская область',
      'Рязанская область',
      'Самарская область',
      'Санкт-Петербург',
      'Саратовская область',
      'Сахалинская область',
      'Свердловская область',
      'Севастополь',
      'Северная Осетия - Алания',
      'Смоленская область',
      'Ставропольский край',
      'Тамбовская область',
      'Татарстан',
      'Тверская область',
      'Томская область',
      'Тульская область',
      'Тыва',
      'Тюменская область',
      'Удмуртия',
      'Ульяновская область',
      'Хабаровский край',
      'Хакасия',
      'Ханты-Мансийский АО - Югра',
      'Челябинская область',
      'Чечня',
      'Чувашия',
      'Чукотский АО',
      'Якутия',
      'Ямало-Ненецкий АО',
      'Ярославская область'
    ],
    e6: 1,
    vol: {
      volume: '',
      arr: [],
      newarr: [],
      sum: 0,
    },
    mv: 'kvt',
    drawer: true,
    consuption: 0,
    dkp: {
      ck1: null,
      ck3: null,
      ck4: null
    },
    checking: false,
    redirect_type:null,
    dialog: false,
    picker: new Date().toISOString().substr(0, 7),
    calculating: false,
    haveVolume: true,
    client_type: null,
    regions: [],
    zone_id: null,
    step1Ability: false,
    region_id: null,
    zones: [],
    zone: null,
    voltage_level: 'nn',
    category: 1,
    price_category: 1,
    hasEP: false,
    integral_volume: null,
    volume_file: undefined,
    result: false,
    visitor_id: 0,
    cf: true,
    calculated: {
      ck1: {
        total: '-',
        tarif: '-'
      },
      ck2: {
        total: '-',
        tarif: '-'
      },
      ck3: {
        total: '-',
        tarif: '-'
      },
      ck4: {
        total: '-',
        tarif: '-'
      },
    },
    contract_type: "dkp",
    contract_types: [{
      type: "dkp",
      label: "Договор Купли-Продажи"
    }, {
      type: "des",
      label: "Договор ЭнергоСнабжения"
    }],
    consumption_type: null,
    voltage_levels: [{
      level: 'vn',
      label: 'ВН'
    }, {
      level: 'sn1',
      label: 'СН-1'
    }, {
      level: 'sn2',
      label: 'СН-2'
    }, {
      level: 'nn',
      label: 'НН'
    },],
    categories: [
      {
        value: 1,
        label: 'менее 670 кВт'
      },
      {
        value: 2,
        label: 'более 670 кВт, менее 10 МВт'
      },
      {
        value: 3,
        label: 'более 10 МВт'
      },
    ],
    tr:'mrsk',
    trs:[  {
      value: 'fsk',
      label: 'ФСК'
    },
      {
        value: 'mrsk',
        label: 'МРСК'
      },],
    price_categories: [
      {
        value: 1,
        label: '1-ая категория'
      },
      {
        value: 2,
        label: '2-ая категория'
      },
      {
        value: 3,
        label: '3-яя категория'
      },
      {
        value: 4,
        label: '4-ая категория'
      },
    ],

    consumption_types: [
      {
        type: 1,
        name: '247',
      },
      {
        type: 2,
        name: 'Ночное',
      },
      {
        type: 3,
        name: 'Дневное',
      },
    ],
    client_types: [
      {
        type: 1,
        name: 'АЗС',
      },
      {
        type: 2,
        name: 'Магазин',
      },
      {
        type: 3,
        name: 'Сотовая вышка',
      },
      {
        type: '',
        name: '....',
      },
    ],
    months: [
      {
        name: 'Январь',
        value: 1,
      },
      {
        name: 'Февраль',
        value: 2,
      }, {
        name: 'Март',
        value: 3,
      }, {
        name: 'Апрель',
        value: 4,
      }, {
        name: 'Май',
        value: 5,
      }, {
        name: 'Июнь',
        value: 6,
      }, {
        name: 'Июль',
        value: 7,
      }, {
        name: 'Август',
        value: 8,
      }, {
        name: 'Сентябрь',
        value: 9,
      }, {
        name: 'Октябрь',
        value: 10,
      }, {
        name: 'Ноябрь',
        value: 11,
      }, {
        name: 'Декабрь',
        value: 12,
      },
    ],

  }),
  watch: {
    helpState:{
      handler(val) {
        if (val==true){
          this.helpEnable();
        }else{
          this.helpDisable();
        }
      }
    },
    $route(to, from) {
      console.log('to', to);
      console.log('from', from);
      if (from.name == 'result') {
        this.result = false;
      }

    },
    region_id: {
      handler(val) {
        this.getZones(val);
      }
    },
    zone_id: {
      handler() {

        this.sendToCheck();
      }
    }
  },
  methods: {
    processManualInput() {
      this.vol.volume = this.manualInput;
      this.convert();
      this.menu123 = false;
      this.manualInput='';
    },
    initParameters(){
      let url = new URL(window.location.href);
      console.log('url',url);
      let searchParams = new URLSearchParams(url.search);
      console.log('searchParams',searchParams);
      const picker=searchParams.get('picker');
      if (picker){

        this.picker=picker;
      }

      const zone_id=searchParams.get('zone_id');
      if (zone_id){
        this.zone_id=zone_id;
      }

      const region_id=searchParams.get('region_id');
      if (region_id){
        this.region_id=region_id;
      }

      const month=searchParams.get('month');
      if (month){
        this.month=month;
      }

      const year=searchParams.get('year');
      if (year){
        this.year=year;
      }

      const voltage_level=searchParams.get('voltage_level');
      if (voltage_level){
        this.voltage_level=voltage_level;
      }


      const category=searchParams.get('category');
      if (category){
        this.category=parseFloat(category);
      }


      const tr=searchParams.get('tr');
      if (tr){
        this.tr=tr;
      }

      const redirect_type=searchParams.get('redirect_type');
      if (redirect_type){
        this.redirect_type=redirect_type;
        if (redirect_type=='prices'){
            this.showredirectLoading=true;
            setTimeout(()=>{
              this.showredirectLoading=false;
              document.getElementById('pr_id_btn').click();
            },5000);
        }
      }

    },
    helpChange() {
      if (this.helpState == true) {
        this.helpEnable();
      } else {
        this.helpDisable();
      }
    },
    helpEnable() {
      this.$store.dispatch('helpEnable')
    },
    helpDisable() {
      this.$store.dispatch('helpDisable')
    },
    goBack() {
      window.history.back();
    },
    metrikaTarget(target) {
      this.$metrika.reachGoal(target)
    },
    toVk() {
      this.metrikaTarget('toVk');
      window.open('https://vk.com/club217230014', '_blank').focus();
    },
    toTg() {
      this.metrikaTarget('toTg');
      window.open('https://t.me/etarif', '_blank').focus();
    },
    getCustomMonth(month) {
      let i = new Date(month).getMonth(month)
      return this.months[i].name;
    },
    backToVolume() {
      this.result = false;
      router.push('/');
    },
    updateChecking() {
      this.generateEmpty();
      this.sendToCheck();
    },
    selectFile() {
      this.metrikaTarget('loadfile');
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    getFromBuffer() {
      this.metrikaTarget('target');
      navigator.clipboard.readText()
          .then(text => {
            this.vol.volume = text;
            //   console.log('fromBuffer',this.vol.volume);
            this.convert();
          })
          .catch(err => {
            console.error('Failed to read clipboard contents: ', err);
          });

    },
    generateEmpty() {
      this.vol.arr = [];
      var dayscount = this.getDaysCount(this.year, this.month);
      var obj = {
        value: 0,
        color: '#fff',
      }
      for (var i = 0; i < dayscount; i++) {
        this.vol.arr[i] = [];
        for (var j = 0; j < 24; j++) {
          this.vol.arr[i][j] = obj;
        }
      }

    },
    sendStatistic() {
      var referrer = '';
      if (document.referrer) {
        referrer = document.referrer;
      }
      axios.get(this.host + '/updatestatistic?spa_referer=' + referrer).then((response) => {
        this.visitor_id = response.data.visitor_id;
        this.region_by_ip = response.data.region_by_ip;
      });
    },
    sendToCheck() {
      this.checking = true;
      var req = {
        value: this.vol.arr,
        month: this.month,
        year: this.year,
        zone: this.zone_id
      };
      axios.post(this.host + '/check1', req).then((response) => {
        this.vol.arr = response.data.volume;
        this.power = response.data.power;
        this.checking = false;
      })
          .catch((error) => {
            console.log(error);
            this.checking = false;
            this.$toast.error('Ошибка отправки на сервер', {})

          })
    },
    toRound(val) {
      var result = Math.round(val * 100) / 100;
      return result.toLocaleString('ru');
    },
    toRoundPower(val) {
      var result = Math.round(val * 100000) / 100000;
      return result;
    },
    pasteConvert() {
      setTimeout(() => {
        this.convert();
      }, 100);
    },
    monthsTrim() {
      //  console.log('vol.lenght',this.vol.arr.length);
      var days_count = this.getDaysCount(this.year, this.month);
      //  console.log('days_count',days_count);
      if (this.vol.arr.length > days_count) {
        //  alert('!!!!!');
        //  console.log('wewewew',this.vol.arr.length - days_count);
        this.vol.arr.splice(days_count, this.vol.arr.length - days_count);
      }

      console.log('volarr', this.vol.arr);
      this.$forceUpdate();

    },

    calculate() {
      var sum = 0;
      var arr = [];
      for (let i = 0; i < this.vol.arr.length; i++) {
        var sarr = this.vol.arr[i];
        arr[i] = [];
        for (let j = 0; j < sarr.length; j++) {
          if (this.mv == 'kvt') {
            arr[i][j] = sarr[j];
          } else {
            arr[i][j] = sarr[j];
          }
          sum = sum + arr[i][j]['value'];
        }
      }

      let fsk =false;
      if (this.tr=='fsk'){
        fsk=true;
      }

      this.obj = {
        month: this.month,
        year: this.year,
        volume: JSON.stringify(arr),
        sum: sum,
        visitor_id: this.visitor_id,
        zone: this.zone_id,
        category: this.category,
        voltage_level: this.voltage_level,
        contract_type: this.contract_type,
        type: this.mv,
        fsk:fsk
      };
      this.calculating = true;
      axios.post(this.host + '/calculate', this.obj).then((response) => {
        if (response.data.errors) {
          this.$toast.error('Нет исходных данных для расчета по ' + this.region_name + ' за ' + this.monthName + ' ' + this.year, {})
          console.log('НЕТ ДАННЫХ', response.data.errors);
        } else {
          router.push('result')

          this.calculating = false;
          this.result = true;
          this.results = response.data.result;
          this.calculation_id=response.data.calculation_id;
          this.vol.sum = response.data.sum;
          this.dkp = response.data.dkp;
          this.calculated = response.data;
          this.e6 = 4;
        }
      }).catch((er) => {
        console.log(er);
        this.$toast.error('Нет исходных данных для расчета по ' + this.region_name + ' за ' + this.monthName + ' ' + this.year, {})
      })
    },
    convert() {
      console.log('volumetext', this.vol.volume);

      let size = 24;
      let subarray = [];
      let array = [];
      this.vol.sum = 0;
      // this.vol.arr = [];
      array = this.vol.volume.split("\n");
      console.log('array', array.length);
      if (this.vol.volume.indexOf('\t') <= -1) {

        //alert('столбец');

        for (let i = 0; i < Math.ceil(array.length / size); i++) {
          subarray[i] = array.slice((i * size), (i * size) + size);
          // this.vol.arr[i] = [];

          for (let j = 0; j < subarray[i].length; j++) {
            if (this.vol.arr[i] && subarray[i][j]) {
              this.vol.arr[i][j] = parseFloat(subarray[i][j].replace(',', '.').replace(' ', ''));

              var obj = {
                value: parseFloat(subarray[i][j].replace(',', '.').replace(' ', '')),
                color: '#fff',
              }
              this.vol.sum = this.vol.sum + parseFloat(this.vol.arr[i][j]['value']);
              this.vol.arr[i][j] = obj;
            }
          }
          if (this.vol.arr[i]) {
            if (this.vol.arr[i].length != 24) {
              this.vol.arr.pop();
            }
          }

        }

        if (this.vol.arr.length < 28) {
          this.$toast.error('данные менее чем за 28 дней', {})
          this.vol.volume = '';
          // let msg = this.monthss[month - 1].label + ' сотоит из ' + this.days_count[month - 1] + " дней , ваша вставка содержит данные за  " + this.note.arr.length + ' день';
        } else {
          this.step1Ability = true;
        }

        if (this.vol.arr.length > 31) {
          this.$toast.error('данные более чем за 31 день', {})
          this.vol.volume = '';

          // let msg = this.monthss[month - 1].label + ' сотоит из ' + this.days_count[month - 1] + " дней , ваша вставка содержит данные за  " + this.note.arr.length + ' день';
        } else {
          this.step1Ability = true;

        }
      } else {


        alert('матрица');

        var arr = [];
        console.log('array', array);
        array.forEach((elem, index) => {
          //console.log('elem',elem);
          var arr_elem = elem.split('\t');
          //  console.log('arr_elem',arr_elem);
          arr[index] = arr_elem;
        })
        console.log('volarr2', this.vol.arr);
        for (var i = 0; i < this.vol.arr.length; i++) {
          for (var j = 0; j < this.vol.arr[i].length; j++) {
            if (arr[i][j]) {
              this.vol.arr[i][j]['value'] = parseFloat(arr[i][j].replace(',', '.'));
            }
          }
        }
      }
      this.sendToCheck();

      // console.log('paste volarr', this.vol.arr);

    },
    reload() {
      window.location.href = location['href'];//.reload();
    },
    toStep2(val) {
      this.e6 = 3;
      this.haveVolume = val;
    },
    getRegions() {
      axios.get(this.host + '/regions').then((response) => {
        this.regions = response.data;
        if (this.region_by_ip) {
          this.regions.forEach((region) => {
            if (region.label.toLowerCase() == this.region_by_ip.toLowerCase()) {
              this.region_id = region.value;
            }
          })
        }
      })
    },
    getDaysCount(year, month) {
      return new Date(year, month, 0).getDate();

    },
    getTemplate() {
      var dayscount = this.getDaysCount(this.year, this.month);
      var url = this.host + "/templates/xlsx/" + dayscount + ".xlsx";
      this.downloadURI(url, 'template');

    },
    downloadURI(uri, name) {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', name);
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getZones() {
      axios.post(this.host + '/zones?region=' + this.region_id).then((response) => {
        this.zones = response.data;
        if (this.zones[0]) {
          this.zone_id = this.zones[0].value;
        }
      })
    },
    getAllZones() {
      axios.post(this.host + '/zones').then((response) => {
        this.zones = response.data;
        if (this.zones[0]) {
          this.zone_id = this.zones[0];
        }
      })
    },
    send() {

      var that = this;
      axios.post('https://api.ieplatform.ru/api/contact-form', this.contactForm)
          .then((response) => {

            this.$toast.success(response.data.value, {})
            this.cf = false;

          })
          .catch((error) => {
            console.log(error);
            that.$toast.error(error.response.data.error, {})

          });


    },

    onFileChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {type: 'binary'});
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const predata = XLSX.utils.sheet_to_json(ws, {header: 1});
          var arr = [];
          arr = predata.splice(4);
          arr.forEach((elem) => {
            elem.shift();
          })
          this.step1Ability = true;
          this.vol.sum = 0;
          var sum = 0;
          for (let index = 0; index < this.vol.arr.length; index++) {
            for (let index1 = 0; index1 < this.vol.arr[index].length; index1++) {
              if (arr[index][index1]) {
                var obj = {
                  value: parseFloat(arr[index][index1].toString().replace(' ', '')),
                  color: '#fff'
                }
                sum = sum + parseFloat(arr[index][index1].toString().replace(' ', ''));
                this.vol.arr[index][index1] = obj;
              }
            }
          }
          this.vol.sum = sum;
          document.getElementById('ifile').value = null;
          this.sendToCheck();
          this.monthsTrim();
        }
        reader.readAsBinaryString(this.file);
      }
    },
    fileToJson(e) {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        const bstr = e.target.result
        const wb = XLSX.read(bstr, {type: 'binary'})
        const wsname = wb.SheetNames[0]
        const ws = wb.Sheets[wsname]
        const data = XLSX.utils.sheet_to_json(ws, {header: 1})
        console.log(data);
      }
      reader.readAsBinaryString(file)
    },
    volumeUpload() {
    }
  },
  computed: {
  //  helpState(){
    //  return this.$store.state.help;
  //  },
    mainStyle(){
      if(this.result){
        return ' ';
      }
      return 'mainscroll';
    },
    navStyle() {
      if (this.isMobile) {
        return "max-height: 100vh !important; margin:";
      }
      return "max-height: 100vh !important;";
    },
    footerStyle() {
      if (this.isMobile) {
        return "margin-top: auto !important; bottom: -6px !important;";

      }
      return "margin-top: auto !important; bottom: 64px !important;";
    },
    currentDay() {
      const date = new Date();

      let day = date.getDate();
      return day;
    },
    pricecesTarifsTitle() {
      var title = '';
      title = this.region_name + ', ' + this.zone_name + ', ' + this.voltage_name + ', ' + this.category_name + " за " + this.monthName + " " + this.year;
      return title;
    },
    startPicker() {
      var endDate = new Date(this.date.getFullYear(), this.date.getMonth() - 2, 10);
      return endDate.toISOString().slice(0, 7)
    },
    permanentDrawer() {
      return true;
    },
    drawersWidth() {
      if (this.isMobile) {
        return '100%';
      }
      return 340;
    },
    sum() {
      var sum = 0;
      var arr = [];
      for (let i = 0; i < this.vol.arr.length; i++) {
        var sarr = this.vol.arr[i];
        arr[i] = [];
        for (let j = 0; j < sarr.length; j++) {
          if (this.mv == 'kvt') {
            arr[i][j] = sarr[j];
          } else {
            arr[i][j] = sarr[j];
          }
          sum = sum + arr[i][j]['value'];
        }
      }
      return sum;
    },
    urlResult() {
      if (window.location.href.indexOf('result') > -1) {
        return true;
      }
      return false;
    },
    month() {
      return parseInt(this.picker.slice(5, 7));
    },
    /* eslint-disable */

    zone_name() {
      var zone_name = '';
      if (this.zone_id) {
        this.zones.forEach((zone) => {
          if (this.zone_id == zone.value) {
            zone_name = zone.label;
          }
        })
      }
      return zone_name;
    },
    region_name() {
      var region_name = '';
      if (this.region_id) {
        this.regions.forEach((region) => {
          if (this.region_id == region.value) {
            region_name = region.label;
          }
        })
      } else {
        region_name = "неизвестному региону";
      }
      return region_name;
    },
    category_name() {
      var category_name = '';
      if (this.category) {
        this.categories.forEach((cat) => {
          if (this.category == cat.value) {
            category_name = cat.label;
          }
        })
      }
      return category_name;
    },
    voltage_name() {
      var voltage_name = '';
      if (this.voltage_level) {
        this.voltage_levels.forEach((vol) => {
          if (this.voltage_level == vol.level) {
            voltage_name = vol.label;
          }
        })
      }
      return voltage_name;
    },
    getEndDate() {
      var endDate = new Date(this.date.getFullYear(), this.date.getMonth() - 1, 10);
      if (this.currentDay < 11) {
        var endDate = new Date(this.date.getFullYear(), this.date.getMonth() - 2, 10);
      }
      return endDate.toISOString().slice(0, 10)
    },

    year: function () {
      return this.picker.slice(0, 4);
    },
    monthName() {
      return this.months[this.month - 1].name;
    },
    host() {
      return process.env.VUE_APP_HOST;
    },
    step2ability() {
      if (this.zone_id) {
        return true;
      }
      return false;
    },

    disabled() {
      if (!this.zone_id) {
        return true;
      }
      return false;
    },
    know_label() {
      if (this.know) {
        return 'Я знаю свой почасовой объем потребления';
      } else {
        return "Я не знаю свой почасовой объем потребления"
      }
    },

    showStep2() {
      if (this.volume_file || this.consumption_type) {
        return true;
      }
      return false;
    },
    showStep3() {
      if (this.zone_id) {
        return true;
      }
      return false;
    },
    btnAbility() {
      if (this.zone_id) {
        return false;
      }
      return true;
    },
    years() {
      const currentYear = (new Date()).getFullYear();
      const range = (start, stop, step) => Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));
      return (range(currentYear, 2019, -1));
    },

  },
  mounted() {
    this.sendStatistic();
    this.year = this.years[1];
    this.picker = this.startPicker;
    this.generateEmpty();
    this.sendToCheck();
    //this.getAllZones();
    this.getRegions();
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() - 1;
    this.initParameters();

  }

}
</script>
<style>
.mainscroll{
  height: calc(100vh - 112px) !important;
}
.v-input--selection-control{
  margin-top: 12px !important;
  padding-top: 12px !important;

}
.v-date-picker-table--month td {
  height: 32px !important;
}

.v-picker__title {
  display: none !important;
}

.v-date-picker-table {
  height: 156px !important;
}

</style>

